import script from "./AmountField.vue?vue&type=script&setup=true&lang=js"
export * from "./AmountField.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import InputField from "@/components/neue/InputField.vue";
script.components = Object.assign({}, { InputField }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { InputField }, script.__o.components);}